import { Button } from "./ui/button";

export default function EmptyState({
    title,
    description,
    buttonText,
    onClear,
}: {
    title: string;
    description: string;
    buttonText?: string;
    onClear: () => void;
}) {
    return (
        <div className="text-center py-12">
            <p className="text-gray-500 text-lg mb-4 font-medium">{title}</p>

            {description && <p className="text-gray-500 text-sm mb-4">{description}</p>}

            {buttonText && (
                <Button
                    onClick={onClear}
                    variant="primary"
                    size="lg"
                    className="font-medium"
                >
                    {buttonText}
                </Button>
            )}
      </div>
    )
}